import React from 'react';
import { useIntl } from 'react-intl-next';
import { alignmentMessages as messages } from '@atlaskit/editor-common/messages';
import AlignTextCenterIcon from '@atlaskit/icon/core/migration/align-text-center--editor-align-center';
import AlignTextLeftIcon from '@atlaskit/icon/core/migration/align-text-left--editor-align-left';
import AlignTextRightIcon from '@atlaskit/icon/core/migration/align-text-right--editor-align-right';
var iconAndMessageMap = {
  start: {
    Component: AlignTextLeftIcon,
    label: messages.alignLeft
  },
  end: {
    Component: AlignTextRightIcon,
    label: messages.alignRight
  },
  center: {
    Component: AlignTextCenterIcon,
    label: messages.alignCenter
  }
};
export var IconMap = function IconMap(props) {
  var _iconAndMessageMap$pr = iconAndMessageMap[props.alignment],
    Component = _iconAndMessageMap$pr.Component,
    label = _iconAndMessageMap$pr.label;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Component, {
    label: intl.formatMessage(label),
    color: "currentColor",
    spacing: "spacious"
  });
};